<script setup lang="ts">
  withDefaults(defineProps<{ size?: number | string }>(), { size: 16 })
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <rect x="2" y="6" width="20" height="12" rx="1" />
    <line x1="6" y1="14" x2="6" y2="18" />
    <line x1="10" y1="14" x2="10" y2="18" />
    <line x1="14" y1="14" x2="14" y2="18" />
    <line x1="18" y1="14" x2="18" y2="18" />
  </svg>
</template>
